<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'BlocConnaitreMonOpco'
});
</script>
<template>
  <ka-container
    code="bloc-connaitre-mon-opco"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-text code="comment-connaitre-mon">
      <span v-html="t('blocConnaitreMonOpco.commentConnaitreMon.value', `Comment connaître mon OPCO ?`)" />
    </ka-text>
    <ka-text code="votre-opco-est-determine">
      <span v-html="t('blocConnaitreMonOpco.votreOpcoEstDetermine.value', `Votre <strong>OPCO</strong> est déterminé d’après votre <strong>convention collective</strong>, elle-même déterminée d’après votre<strong> code APE</strong> (ou code NAF).`)" />
    </ka-text>
    <!-- Schéma -->
    <ka-container code="schema">
      <ka-text code="code-ape-ou-naf">
        <span v-html="t('blocConnaitreMonOpco.schema.codeApeOuNaf.value', `Code APE (ou NAF)`)" />
      </ka-text>
      <ka-icon
        code="icon"
        value="i-fa-solid:arrow-circle-right" />
      <ka-text code="convention-collective">
        <span v-html="t('blocConnaitreMonOpco.schema.conventionCollective.value', `Convention collective`)" />
      </ka-text>
      <ka-icon
        code="icon-1"
        value="i-fa-solid:arrow-circle-right" />
      <ka-text code="opco">
        <span v-html="t('blocConnaitreMonOpco.schema.opco.value', `OPCO`)" />
      </ka-text>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { blocConnaitreMonOpcoComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c33')
const component = blocConnaitreMonOpcoComponent()
const componentInstance = component.newStoreInstance()
withDefaults(defineProps<{
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

syncComponentStore(componentInstance)
</script>
